import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { billingKeys } from '../queries/keys';
import { billingPaths } from '../queries/paths';

// TSS vite/03 — liquidaciones mensuales (admin-billing-liquidations.md). Corrida por
// (año,mes): días derivados de las estadías × tarifa vigente → pensión + reparto por
// dueño (congelado). draft→generated→posted→reversed. Permiso billing:*.

export function useBatches(filters) {
    return useQuery({
        queryKey: billingKeys.batches(filters),
        queryFn:  ({ signal }) => api.get(billingPaths.batches(), { params: filters, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
    });
}

export function useBatch(id) {
    return useQuery({
        queryKey: billingKeys.batch(id),
        queryFn:  ({ signal }) => api.get(billingPaths.batch(id), { signal }).then(r => r.data),
        enabled:  !!id,
    });
}

// Drill-down vaca-mes (Q-118): pensión + ajustes + subtotal neto (paridad v1).
export function useCowLiquidation(animalId, year, month) {
    return useQuery({
        queryKey: billingKeys.cowLiq(animalId, year, month),
        queryFn:  ({ signal }) => api.get(billingPaths.cowLiquidations(), { params: { animal_id: animalId, year, month }, signal }).then(r => r.data),
        enabled:  !!animalId && !!year && !!month,
        placeholderData: (prev) => prev,
    });
}

export function useGenerateBatch() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(billingPaths.batches(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

export function usePostBatch() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.post(billingPaths.batchPost(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

export function usePostLedger() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.post(billingPaths.batchLedger(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

// Reversa por nota-crédito de un batch `posted` (append-only; no borra). → `reversed`.
export function useReverseBatch() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.post(billingPaths.batchReverse(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}
